




























































import { Component, Prop, Vue, Watch } from 'vue-property-decorator';
import LabelOperation from '@/components/label/labelOperation.vue';
import CommentList from '@/components/comment/commentList.vue';
import ContentDetail from './contentDetail.vue';
import { createLabelUrl } from '@/components/label/labelOperation';
import { createCommentUrl } from '@/components/comment/commentOperation';
import { calculateManDay, convertJsonData } from '@/utils/payment';
import DetailBox from '@/components/detailBox/detailBox.vue';

type IPaymentInfo = IPayment.IResponse.IPaymentInfo;
type ILabelInfo = ILabel.IResponse.ILabelInfo;
type ICreateOrUpdateComment = IComment.IRequest.ICreateOrUpdateComment;

@Component({
  components: {
    LabelOperation,
    CommentList,
    ContentDetail,
    DetailBox,
  },
})
export default class PaymentDetail extends Vue {
  @Prop({default: false}) private spinning!: boolean;
  @Prop({required: true}) private payment!: IPaymentInfo;
  get contentData() {
    return convertJsonData(this.payment.jsonData);
  }
  get manDay() {
    return calculateManDay(this.payment.items);
  }
  get paymentId(): string {
    if (this.payment) {
      return this.payment.id;
    } else {
      return '';
    }
  }
  get labelUrl() {
    return createLabelUrl('Payment', this.paymentId);
  }
  get commentUrl() {
    return createCommentUrl('Payment', this.paymentId);
  }
  @Watch('paymentId')
  private watchPaymentId(paymentId: string) {
    if (paymentId) {
      this.requestPaymentDetail();
    }
  }
  private requestPaymentDetail() {
    this.$emit('refreshDetail', this.payment);
  }
  private editPayment() {
    this.$emit('edit', this.payment);
  }
  private handleUpdateStatus(status: IPayment.IPaymentStatus) {
    this.$emit('statusChange', {
      payment: this.payment,
      status,
    });
  }
  private removePayment() {
    this.$emit('delete', this.paymentId);
  }
  private handleCommentAdd(newComment: ICreateOrUpdateComment) {
    this.$emit('commentChange', {
      payment: this.payment,
      comment: newComment,
      type: 'ADD',
    });
  }
  private handleLabelChange(newLabels: ILabelInfo[]) {
    this.$emit('labelChange', { payment: this.payment, labels: newLabels });
  }
  private goSolutionPage(solutionId: string) {
    this.$router.push({
      name: 'Solution',
      params: {
        id: solutionId,
      },
    });
  }
}
